import React from 'react';
import './styles/stepper.css';
import { stepperMessages } from './traductor/stepper';

type StepState = 'completed' | 'current' | 'pending';

const STEP_STATES_BY_TIPO: { [key: string]: StepState[] } = {
  auto: ['completed', 'completed', 'completed', 'pending'],
  pending: ['completed', 'current', 'pending', 'pending'],
  omitted: ['completed', 'pending', 'pending', 'pending'],
  regular: ['completed', 'pending', 'pending', 'pending'],
};

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
    <path d="M5 12.5l4.2 4.2L19 7" stroke="#FFF" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const RefreshIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="#FFF" aria-hidden="true">
    <path d="M17.65 6.35A7.96 7.96 0 0 0 12 4a8 8 0 1 0 7.73 10h-2.08A6 6 0 1 1 12 6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
  </svg>
);

const isReached = (state: StepState | undefined) => state === 'completed' || state === 'current';

interface StepperProps {
  language: string;
  tipo: string;
}

const Stepper = ({ language, tipo }: StepperProps) => {
  const states = STEP_STATES_BY_TIPO[tipo];
  if (!states) return null;

  const labels = stepperMessages[language] ?? stepperMessages.es;

  return (
    <div className="ole-stepper">
      {states.map((state, index) => {
        const isLast = index === states.length - 1;
        const lineActive = isReached(states[index + 1]);
        return (
          <div className={`ole-stepper__step ole-stepper__step--${state}`} key={index}>
            <div className="ole-stepper__marker">
              <span className="ole-stepper__dot">
                {state === 'completed' && <CheckIcon />}
                {state === 'current' && <RefreshIcon />}
                {state === 'pending' && <span className="ole-stepper__inner-dot" />}
              </span>
              {!isLast && (
                <span className={`ole-stepper__line${lineActive ? ' ole-stepper__line--active' : ''}`} />
              )}
            </div>
            <div className="ole-stepper__label">{labels[index]}</div>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
